import request from '@/services/interceptor.js'

export const get_obiettivi = (par, anno) => {
    return request({
        url: '/api/obiettivi/riepilogo/' + par + "/" + anno,
        method: 'get'
    })
};

export const set_obiettivo = (data) => {
    return request({
        url: '/api/obiettivi/obiettivo/modifica',
        method: 'post',
        data: data
    })
};